import styled from "styled-components";

import { breakpoints } from "../../../constants/breakpoints";

export const Wrap = styled.div`
  /* Mobile / default */
  & > .container {
    & > z-button {
      width: 100%;
    }
  }

  & > .borders {
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
  }

  /* Tablet breakpoint */
  @media only screen and (min-width: ${breakpoints.tablet}px) {
    & > .container {
      width: 75%;
    }

    & > .container {
      & > z-button {
        width: unset;
      }
    }
  }

  /* Desktop breakpoint */
  @media only screen and (min-width: ${breakpoints.desktop}px) {
    & > .container {
      width: 50%;
    }
  }

  /* Desktop Wide breakpoint */
  @media only screen and (min-width: ${breakpoints.desktopWide}px) {
  }
`;
